/* eslint-disable @typescript-eslint/no-unused-vars */
import { FormItem } from '@microsec/models';
import { IDS_FORM_PARAMS } from './../shared-active-scan-form.component';
import { OnInit, Component, ViewChild } from '@angular/core';
import { FormBuilderComponent } from '@microsec/components';
import { ValidationErrors } from '@angular/forms';

// Accept Individual IP, IP + subnet mask and IP range
export const IPV4_ADDRESS_OR_RANGE_PATTERN =
  '^(?:' +
  '(25[0-5]|2[0-4][0-9]|1?[0-9][0-9]?)\\.' + // 1st octet
  '(25[0-5]|2[0-4][0-9]|1?[0-9][0-9]?)\\.' + // 2nd octet
  '(25[0-5]|2[0-4][0-9]|1?[0-9][0-9]?)\\.' + // 3rd octet
  '(25[0-5]|2[0-4][0-9]|1?[0-9][0-9]?)' + // 4th octet (full IPv4)
  ')' +
  '(?:-(?:' +
  '(25[0-5]|2[0-4][0-9]|1?[0-9][0-9]?)\\.' + // 1st octet (end range)
  '(25[0-5]|2[0-4][0-9]|1?[0-9][0-9]?)\\.' + // 2nd octet (end range)
  '(25[0-5]|2[0-4][0-9]|1?[0-9][0-9]?)\\.' + // 3rd octet (end range)
  '(25[0-5]|2[0-4][0-9]|1?[0-9][0-9]?)' + // 4th octet (end range)
  '))?' + // Optional range
  '(?:/(3[0-2]|[12]?[0-9]))?$'; // CIDR subnet mask (1-32)

@Component({
  selector: 'app-sas-ip-range',
  templateUrl: './sas-ip-range.component.html',
  styleUrls: ['./sas-ip-range.component.scss'],
  imports: [FormBuilderComponent],
})
export class SasIpRangeComponent implements OnInit {
  fields: FormItem[] = [];

  IDS_FORM_PARAMS = IDS_FORM_PARAMS;

  @ViewChild('fb') form!: FormBuilderComponent;

  ngOnInit(): void {
    const ipRangeExtraValidation = (currentValue: string) => {
      const colonIndex = currentValue.indexOf('-');
      if (colonIndex > -1) {
        const invalidError: ValidationErrors = { incorrect: true, message: 'Invalid IP range' };
        const [startIP, lastIp] = currentValue.split('-');
        const startIpOctets: string[] = startIP.split('.');
        const lastIpOctets: string[] = lastIp.split('.');
        if (startIpOctets.length !== 4 && lastIpOctets.length !== 4) {
          return invalidError;
        }
        for (let i = 0; i < 4; i++) {
          if (Number(startIpOctets[i]) < Number(lastIpOctets[i])) break;
          if (Number(startIpOctets[i]) > Number(lastIpOctets[i])) return invalidError;
        }
      }
      return null;
    };
    const fields: FormItem[] = [
      Object.assign(new FormItem(), {
        name: IDS_FORM_PARAMS.NETWORKS,
        label: 'Select IP Ranges or Addresses',
        field: 'input-chip',
        fieldInfo:
          'Enter the IP address or IP range. For IP range, indicate the subnet mask in CIDR notation (e.g. /25). For example, enter 11.1.15.0/25 or IP range like 1.1.1.1-1.2.3.4',
        placeholder: 'Input IP Ranges or Addresses. Use comma (,) as delimiter.',
        regex: IPV4_ADDRESS_OR_RANGE_PATTERN,
        defaultValue: [],
        extraValidation: ipRangeExtraValidation,
        minValue: 0,
        required: true,
      } as FormItem),
      Object.assign(new FormItem(), {
        name: IDS_FORM_PARAMS.EXCLUDE_NETWORKS,
        label: 'IP Ranges or Addresses to Exclude',
        field: 'input-chip',
        fieldInfo:
          'Enter the IP address or IP range. For IP range, indicate the subnet mask in CIDR notation (e.g. /25). For example, enter 11.1.15.0/25 or IP range like 1.1.1.1-1.2.3.4',
        placeholder: 'Input IP Ranges or Addresses to Exclude. Use comma (,) as delimiter.',
        regex: IPV4_ADDRESS_OR_RANGE_PATTERN,
        defaultValue: [],
        extraValidation: ipRangeExtraValidation,
      } as FormItem),
    ];
    fields.forEach((field) => {
      field.isFullSize = true;
    });
    this.fields = fields;
  }
}
